const switchcase = cases => defaultCase => key => cases.hasOwnProperty(key) ? cases[key] : defaultCase
const executeIfFunction = f => f instanceof Function ? f() : f

export default cases => defaultCase => key => executeIfFunction(switchcase(cases)(defaultCase)(key))


